import React, { Suspense } from "react";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { defineMessages, injectIntl } from "react-intl";
import { TemplateCard } from "../../../../components/single-registry/modals/TemplateDownloadModal/TemplateDownloadModal";
import {
  CustomDocumentIcon,
  CustomDocumentWithLinesIcon,
} from "../../../../common/icons";
import LoadInWidget from "../../../../helpers/loadInWidget";
import { translations } from "./constants";
import { styles } from "./TemplateDownloadModalWidget.styles";
import { handleDownloadTemplate } from "../../../../components/single-registry/modals/TemplateDownloadModal/constants";

const messages = defineMessages(translations);

function TemplateDownloadModalWidget({
  open,
  onClose,
  companyId,
  integratorsSolutionsCode,
  intl,
  locale,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState({ empty: false, filled: false });

  const handleDownload = async (type) => {
    handleDownloadTemplate({
      type,
      companyId,
      integratorsSolutionsCode,
      locale,
      setIsLoading,
      onSuccess: (t) => setStatus((prev) => ({ ...prev, [t]: true })),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth={true}
      PaperProps={{ style: styles.dialogPaper }}
    >
      {isLoading && (
        <Suspense fallback={<div />}>
          <div style={styles.loadingOverlay}>
            <LoadInWidget edenredLogo={true} />
          </div>
        </Suspense>
      )}

      <DialogTitle id="alert-dialog-title" style={styles.dialogTitle}>
        <Typography style={styles.titleText}>
          {intl.formatMessage(messages.title)}
        </Typography>
        <button onClick={onClose} style={styles.closeButton}>
          <span aria-hidden="true">&times;</span>
        </button>
      </DialogTitle>

      <DialogContent>
        <Typography style={styles.subtitle}>
          {intl.formatMessage(messages.subtitle)}
        </Typography>

        <div style={{ display: "flex", marginTop: "2rem" }}>
          <div style={{ marginRight: "32px" }}>
            <TemplateCard
              intl={intl}
              icon={CustomDocumentIcon}
              title={intl.formatMessage(messages.emptySheetTitle)}
              description={intl.formatMessage(messages.emptySheetDescription)}
              isDownloaded={status.empty}
              onDownload={() => handleDownload("empty")}
            />
          </div>

          <TemplateCard
            intl={intl}
            icon={CustomDocumentWithLinesIcon}
            title={intl.formatMessage(messages.filledSheetTitle)}
            description={intl.formatMessage(messages.filledSheetDescription)}
            isDownloaded={status.filled}
            onDownload={() => handleDownload("filled")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default injectIntl(TemplateDownloadModalWidget);
